import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@iconify/react';
import { getTaskDetails, updateTask } from '../../../redux/actions/SocietyPortal/TaskAction/TaskAction';
import TaskForm from './TaskForm';

const EditTask = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const dispatch = useDispatch();
    const { taskDetailsData, taskDetailsLoading, updateTaskLoading } = useSelector((s) => s.TaskReducer);

    useEffect(() => {
        dispatch(getTaskDetails({ taskId: id }));
    }, [dispatch, id]);

    const handleSubmit = (payload) => {
        dispatch(updateTask({
            taskId: id,
            ...payload,
            onSuccess: () => navigate(`/society-portal/tasks/view/${id}`),
        }));
    };

    if (taskDetailsLoading || !taskDetailsData || String(taskDetailsData.task_id) !== String(id)) {
        return (
            <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-100 tw-text-center tw-py-12">
                <Icon icon="mdi:loading" className="tw-text-4xl tw-text-blue-500 tw-animate-spin" />
                <p className="tw-text-gray-500 tw-mt-2 tw-text-sm">Loading task...</p>
            </div>
        );
    }

    return <TaskForm mode="edit" initialValues={taskDetailsData} submitting={updateTaskLoading} onSubmit={handleSubmit} />;
};

export default EditTask;
